module.exports = __webpack_public_path__ + "static/media/dumbbellQuestion.1062fe47.png";